<template>
    <div id="reportsListDlg" class="modal" tabindex="-1" role="dialog" aria-labelledby="reportsListDlgTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
            <form class="modal-content dialog-content">
                <div class="modal-body wizard-body">
                    <h5 class="modal-title wizard-title" id="reportsListDlgTitle">
                        Saved Reports
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        style="z-index: 9; width: 30px;">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div class="container-fluid teeth-list">
                        <div class="report-ctrl" v-for="report in context.savedCutReports">
                            <div class="an-name" :title="report.reportName">{{ report.name }}
                            </div>

                            <img class="item-btn item-link" v-on:click="openClick(report)" title="Open"
                                :src="'images/books.png'" />
                            <img class="item-btn item-link" v-on:click="copyLinkClick(report)" title="Copy Link"
                                :src="'images/copy_icon.png'" />
                            <img class="item-btn" v-on:click="removeClick(report)" title="Delete"
                                :src="'images/trash_icon_red.png'" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer wizard-footer">
                    <button type="button" class="btn btn-primary btn-next" aria-label="OK" v-on:click="close()">
                        OK
                    </button>
                    <input id="reportLinkCtrl" readonly class="form-control" type="text" placeholder=""
                        v-on:keydown.stop>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import swal from "sweetalert";
import { removePdfReport } from "./DicomCutReports.js";

export default {
    name: "ReportsListDlg",
    props: ["context"],
    methods: {
        openClick: async function (report) {
            console.log("openClick");
            window.open(report.url, '_blank');
        },
        copyLinkClick: async function (report) {
            console.log("copyLinkClick");
            let text = report.url;
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text)
                    .then(() => {
                        swal("Link copied to clipboard");
                    })
                    .catch(err => console.error('Copy Error:', err));
            } else {
                $("#reportLinkCtrl").val(text);
                let copyText = document.getElementById("reportLinkCtrl");
                copyText.select();
                copyText.setSelectionRange(0, 99999); /*For mobile devices*/
                document.execCommand("copy");
                swal("Link copied to clipboard");
                copyText.setSelectionRange(0, 0);
            }
        },
        removeClick: async function (report) {
            removePdfReport(report);
        },
        close: async function () {
            $("#reportsListDlg").modal("hide");
        }
    }
};

</script>

<style scoped>
@import "@/css/wizard.css";

#reportLinkCtrl {
    top: 0;
    left: 0;
    position: fixed;
    opacity: 0;
}

.teeth-list {
    /* background: #77a7fd; */
    margin-top: 25px;
    margin-bottom: 10px;
    overflow-y: auto;
    scrollbar-width: thin;
    width: 100%;
    max-height: 500px;
}

.report-ctrl {
    display: flex;
    align-items: stretch;
    gap: 4px;
    width: 100%;
    border-bottom: 1px solid #D9E6FE;
    padding: 3px 0;
}

.an-name {
    margin-top: 1px;
    white-space: nowrap;
    /* text-wrap: nowrap; */
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    flex-grow: 1;
    max-width: calc(100% - 68px);
}

.item-btn {
    margin-top: 1px;
    height: 20px;
    width: 20px;
    cursor: pointer;
}

.item-link {
    margin-top: 2px;
}

#reportsListDlgTitle {
    position: absolute;
    width: 200px;
    left: calc(50% - 100px);
    top: 12px;
}

.dialog-content {
    background-color: white;
    /* background-color: #e6effe; */
    border-radius: 0;
}

.modal-sm {
    max-width: 500px;
    text-align: left;
}

.modal-header {
    height: 60px;
}

.modal-title {
    max-width: 270px;
    left: 45px;
    /* calc(50% - 55px); */
}

.modal-body {
    min-height: 100px;
    /* max-height: 500px; */
    padding-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
}

.close {
    margin-right: -10px;
    margin-top: -20px;
}
</style>